import { render, staticRenderFns } from "./modal-action-title.vue?vue&type=template&id=87eb9826&scoped=true"
import script from "./modal-action-title.vue?vue&type=script&lang=js"
export * from "./modal-action-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eb9826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87eb9826')) {
      api.createRecord('87eb9826', component.options)
    } else {
      api.reload('87eb9826', component.options)
    }
    module.hot.accept("./modal-action-title.vue?vue&type=template&id=87eb9826&scoped=true", function () {
      api.rerender('87eb9826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-prize/modal-action-title.vue"
export default component.exports